import { render, staticRenderFns } from "./ProgramLogoSettings.vue?vue&type=template&id=489e41c9&lang=pug&"
import script from "./ProgramLogoSettings.vue?vue&type=script&lang=js&"
export * from "./ProgramLogoSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports